import { AUDIT_HISTORY_TYPES } from './audit-history-types';

export const AUDIT_HISTORY_MESSAGES = {
  [AUDIT_HISTORY_TYPES.abm.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_ABM_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_ABM_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_ABM_DELETED'
  },
  [AUDIT_HISTORY_TYPES.ads.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_AD_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_AD_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_AD_DELETED'
  },
  [AUDIT_HISTORY_TYPES.bizcards.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_BIZCARD_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_BIZCARD_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_BIZCARD_DELETED'
  },
  [AUDIT_HISTORY_TYPES.bizcardroutes.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_BIZCARD_ROUTES_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_BIZCARD_ROUTES_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_BIZCARD_ROUTES_DELETED'
  },
  [AUDIT_HISTORY_TYPES.brandkit.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_EMPLOYEE_BRANDING_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_EMPLOYEE_BRANDING_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_EMPLOYEE_BRANDING_DELETED'
  },
  [AUDIT_HISTORY_TYPES.brandkitroutes.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_EMPLOYEE_BRANDING_ROUTES_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_EMPLOYEE_BRANDING_ROUTES_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_EMPLOYEE_BRANDING_ROUTES_DELETED'
  },
  [AUDIT_HISTORY_TYPES.domain.id]: {
    update: 'label.AUDIT_HISTORY_ACTION_DOMAIN_UPDATED'
  },
  [AUDIT_HISTORY_TYPES.domainsettings.id]: {
    update: 'label.AUDIT_HISTORY_ACTION_DOMAINSETTINGS_UPDATED'
  },
  [AUDIT_HISTORY_TYPES.documents.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_DOCUMENTS_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_DOCUMENTS_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_DOCUMENTS_DELETED'
  },
  [AUDIT_HISTORY_TYPES.images.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_IMAGES_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_IMAGES_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_IMAGES_DELETED'
  },
  [AUDIT_HISTORY_TYPES.csv.id]: {
    pushfrontapp: 'label.AUDIT_HISTORY_ACTION_FRONTAPP_PUSHED',
    pushgoogle: 'label.AUDIT_HISTORY_ACTION_GOOGLE_PUSHED',
    pusho365: 'label.AUDIT_HISTORY_ACTION_CSV_PUSHED',
    pushsalesforce: 'label.AUDIT_HISTORY_ACTION_SALESFORCE_PUSHED',
    pushoutreach: 'label.AUDIT_HISTORY_ACTION_OUTREACH_PUSHED',
    pushemail: 'label.AUDIT_HISTORY_ACTION_EMAIL_PUSHED'
  },
  [AUDIT_HISTORY_TYPES.manual.id]: {
    login: 'label.AUDIT_HISTORY_ACTION_MANUAL_LOGIN',
    editfrontapp: 'label.AUDIT_HISTORY_ACTION_MANUAL_EDIT_FRONTAPP',
    editgoogle: 'label.AUDIT_HISTORY_ACTION_MANUAL_EDIT_GOOGLE',
    updateuser: 'label.AUDIT_HISTORY_ACTION_MANUAL_UPDATED_USER',
    syncsalesforceusers: 'label.AUDIT_HISTORY_ACTION_MANUAL_SYNCED_USER',
    syncgappsgroups: 'label.AUDIT_HISTORY_ACTION_MANUAL_SYNCED_USER',
    syncgappsorgs: 'label.AUDIT_HISTORY_ACTION_MANUAL_SYNCED_USER',
    syncgappsusers: 'label.AUDIT_HISTORY_ACTION_MANUAL_SYNCED_USER',
    syncbamboohrusers: 'label.AUDIT_HISTORY_ACTION_MANUAL_SYNCED_USER',
    synccalendlyusers: 'label.AUDIT_HISTORY_ACTION_MANUAL_SYNCED_USER',
    synccsvusers: 'label.AUDIT_HISTORY_ACTION_MANUAL_SYNCED_USER',
    syncfrontappusers: 'label.AUDIT_HISTORY_ACTION_MANUAL_SYNCED_FRONTAPP',
    syncmangoappsusers: 'label.AUDIT_HISTORY_ACTION_MANUAL_SYNCED_USER',
    synco365users: 'label.AUDIT_HISTORY_ACTION_MANUAL_SYNCED_USER',
    synco365groups: 'label.AUDIT_HISTORY_ACTION_MANUAL_SYNCED_USER'
  },
  [AUDIT_HISTORY_TYPES.outlookaddin.id]: {
    updateuser: 'label.AUDIT_HISTORY_ACTION_ADDIN_UPDATED_USER'
  },
  [AUDIT_HISTORY_TYPES.plugins.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_PLUGINS_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_PLUGINS_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_PLUGINS_DELETED'
  },
  [AUDIT_HISTORY_TYPES.sendergroups.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_GROUPS_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_GROUPS_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_GROUPS_DELETED'
  },
  [AUDIT_HISTORY_TYPES.signatures.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_SIGNATURES_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_SIGNATURES_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_SIGNATURES_DELETED'
  },
  [AUDIT_HISTORY_TYPES.surveys.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_SURVEYS_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_SURVEYS_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_SURVEYS_DELETED'
  },
  [AUDIT_HISTORY_TYPES.tagblocks.id]: {
    create: 'label.AUDIT_HISTORY_ACTION_TAGBLOCKS_CREATED',
    update: 'label.AUDIT_HISTORY_ACTION_TAGBLOCKS_UPDATED',
    delete: 'label.AUDIT_HISTORY_ACTION_TAGBLOCKS_DELETED'
  },
  [AUDIT_HISTORY_TYPES.user.id]: {
    login: 'label.AUDIT_HISTORY_ACTION_LOGIN',
    custompurge: 'label.PURGED_USERS'
  }
};
